import { render, staticRenderFns } from "./GroupWallet.vue?vue&type=template&id=c4916392"
import script from "./GroupWallet.vue?vue&type=script&lang=ts"
export * from "./GroupWallet.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports